import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import SwitchMembershipSectionWrapper from "../section-wrapper"
import TextArea from 'common/components/elements/inputs/textarea';
import { toast } from 'react-toastify';
import toaster from 'common/utils/toast';
import classNames from 'classnames';
import { addEmojiOnInput, getCurrentPosition, switchShowEmojis } from 'common/utils/utils';
import EmojiContent from 'common/components/modules/emoji-content';
import VariableList from 'common/components/modules/chat/variable-list';


const VARIABLES_LIST = [
   { text: '<site-name>' },
   { text: '<site-link>' },
   { text: '<member-username>' },
   { text: '<admin-screen-name>' },
   { text: '<I/we>' },
   { text: '<my/our>' },
   { text: '<I’m/we’re>' },
   { text: '<I’ve/we’ve>' },
   { text: '<me/us>' },
   { text: '<current-membership>' },
   { text: '<new-membership>' },
]

const PrivateMessageToMember = ({
   onChange,
   value,
   isMobile,
   showOnlyView,
   areaName,
   title,
   errorMessage,
   clearErrorState,
   modalContentWrapperId,
}) => {
   const [cursorPosition, setCursorPosition] = useState(null);

   let textareaRef = useRef(null);

   const handleTextAreaChange = (name, value) => {
      if(value.length > 250) {
         if(!toast.isActive(areaName)){
            toaster.error('250 character limit has been reached',  { toastId: areaName })
         }
         return
      }
      textareaRef.style.height = '42px';
      textareaRef.style.height = (textareaRef.scrollHeight + 2) + 'px';

      const modalContentWrapperEl = document.getElementById(modalContentWrapperId)
      if(modalContentWrapperEl) {
         const scrollTop = modalContentWrapperEl.scrollTop;

         modalContentWrapperEl.scroll({
            top: scrollTop,
            left: 0,
         });
      }
      onChange(name, value)
   }

   const addVariableIntoInput = (value, type = 'input') => {

      const el = textareaRef;

      if(!el) return;

      const start = el.selectionStart;
      const end = el.selectionEnd;

      const text = el.value;

      const newText = text.slice(0, start) + value + text.slice(end);

      el.value = newText;

      const cursorPos = start + value.length;
      el.selectionStart = el.selectionEnd = cursorPos;

      el.focus();

      handleTextAreaChange(areaName, newText)
   }

   const view = (
      <div
         className='w-full flex flex-col gap-2'
      >
         <div
            className='w-full flex justify-between items-end gap-3'
         >
            <span
               className='text-major font-medium leading-5'
            >
               {title} <span className='text-xs leading-[15px] text-secondary font-normal'>(Optional)</span>
            </span>
            <VariableList
               variableList={ VARIABLES_LIST }
               onClickOpen={ () => {} }
               name={ areaName }
               selectorForTooltip='#tooltips'
               selectVariable={ (variable) => {
                  addVariableIntoInput(variable)
               } }
               className='shrink-0'
               doNotOpenListOnTooltip
               scrollIntoViewOnOpenContent
            />
         </div>
         <div
            className='w-full relative'
         >
            <TextArea
               height='auto flex'
               placeholder='Type a message'
               name={ areaName }
               onChange={ handleTextAreaChange }
               value={ value }
               areaClassName={ classNames({
                  '!pl-[14px] !py-2.5': true,
                  'ams-custom-scrool !pr-[42px]': !isMobile,
               }) }
               descriptionPosition='end'
               description={ Boolean(errorMessage) ? null : (value.length === 0 ? 'Minimum 25 character limit' : `${ value.length } of 250 characters used`) }
               descriptionFontWeight='normal'
               TextAreaRef={ ref => textareaRef = ref }
               onTextAreaBlur={ () => {
                  const positionCursor = getCurrentPosition(textareaRef);
                  setCursorPosition(positionCursor);
               } }
               style={ {
                  height: '42px',
               } }
               errorMessage={ errorMessage }
               onSetError={ (bool) => {
                  if(!bool && errorMessage) {
                     clearErrorState()
                  }
               } }
            />
            <EmojiContent
               switchShowEmojis={ () => switchShowEmojis(textareaRef, cursorPosition) }
               addEmoji={ (e) => addEmojiOnInput(e, textareaRef) }
               isMobile={ isMobile }
               style={ {
                  width: '20px',
                  height: '20px',
                  top: '10px',
                  right: '14px',
                  margin: '0',
               } }
               className='absolute right-0 mr-4'
               top='auto'
               id={ `${ areaName }_emoji_icon` }
               xPositions={ {
                  right: '0',
                  top: 'auto',
                  bottom: '134px',
               } }
            />
         </div>
      </div>
   )

   if(showOnlyView) {
      return (
         view
      )
   }

   return (
      <SwitchMembershipSectionWrapper>
         {view}
      </SwitchMembershipSectionWrapper>
   )
}

PrivateMessageToMember.propTypes = {
   onChange: PropTypes.func,
   value: PropTypes.string,
   isMobile: PropTypes.bool,
   showOnlyView: PropTypes.bool,
   areaName: PropTypes.string,
   title: PropTypes.string,
   errorMessage: PropTypes.string,
   clearErrorState: PropTypes.func,
   modalContentWrapperId: PropTypes.string,
}

export default PrivateMessageToMember;
